<template>
  <div class="policy section">
    <div class="container">
      <div class="row">
        <div class="post-box">
          <div class="text-box">
            <h2>MENTIONS LÉGALES DU SITE KIRA RH</h2>
            <p>
              Le site www.kirarh.fr est édité par la société KiraRH, SAS au
              capital de 10.000.000 GNF. La société est immatriculée au Registre
              de Commerce et du Crédit Mobilier sous le numéro…. Son siège
              social est situé à Sonfonia, Commune de Matoto, Conakry,
              République de Guinée. <br /><br />

              Les administrateurs de ce site sont joignables par mail à
              <a href="mailto: recrutement@kirarh.fr">
                recrutement@kirarh.fr
              </a>
              et par téléphone au 664239090 <br /><br />

              Ce site est hébergé par :
              <a href="https://www.o2switch.fr/" target="_blank">O2switch</a
              ><br /><br />

              La société ….. ayant son siège social au<br /><br />

              Numéro de siret : <br /><br />
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Notice",
};
</script>

<style scoped></style>
